<template>
  <div class="wrapper-content w-100">
    <LmComponentLoading v-if="loading" ref="lmComponentLoading" :top="top" />
    <div id="printContainer">
      <div class="documents_lmlistv1">
        <img :src="collapsedLogoImg" alt="" height="46" class="float-right mr-2 logoImg">
        <h2 v-if="customListTitle">{{ customListTitle }}</h2>
        <h2 v-else>{{ title }}</h2>
        <LmBreadcrumb v-if="showBreadcrumb" />
        <h4 v-for="(subTitle, index) in customListSubTitles" :key="index">{{ subTitle }}</h4>
        <LmTableCustom v-if="!loading"
          :order = order
          :orderBySetting = orderBySetting
          :searchOnFields = searchOnFields
          :perPageSetting = perPageSetting
          :itemsPerPage = defaultItemsPerPage
          :limitExportFromClient = limitExportFromClient
          :apiCallPath = apiCallPath
          :highlight = highlight
          :showFilterTime = showFilterTime
          :showGoBackButton = showGoBackButton
          :showPDFButton = showPDFButton
          :showCSVButton = showCSVButton
          :hideSearchSection = hideSearchSection
          :downloadCsvFileName = downloadCsvFileName
          :lmListActions = lmListActions
          @lmCheckedAllSelectedChange="onlmCheckedAllSelectedChange"
          />
      </div>
    </div>
    <LmForm>
      <LmButton
        v-if="this.tableItems.length && showDigitalSignButton"
        id="btn-submit-digital-sign"
        type="submit"
        buttonClass="btn-success"
        :isProcessing="formIsProcessing"
        value="Firmar Seleccionados"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        :disabled="!documentsSelectedCounter"
        @click.native="digitalSign"
        />
      <LmButton
        v-if="this.tableItems.length && showElectronicSignButton"
        id="btn-submit-electronic-sign"
        type="submit"
        buttonClass="btn-success"
        :isProcessing="formIsProcessing"
        value="Firmar Seleccionados"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        :disabled="!documentsSelectedCounter"
        @click.native="electronicSign"
      />
    </LmForm>
    <lmConfirmationModal ref="lmConfirmationModalFirmar" title="Aviso" :message="confirmationModalMessage"/>
    <lmConfirmationModal ref="lmValidationModalFirmarToken" title="Aviso" message="Un código fue enviado a su mail, por favor ingreselo a continuación." @ok="setToken"/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LmForm from '@/components/form/LmForm.vue'
import LmTableCustom from '@/components/LmTableCustom'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmDate from '@/components/form/elements/LmDate'
import LmButton from '@/components/form/elements/LmButton'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
import lmConfirmationModal from '@/components/modals/LmConfirmationModal'
import commonsApi from '@/api/commons'

export default {
  mixins: [lmSuperPowerSelectHelper],
  components: {
    LmForm,
    LmButton,
    LmTableCustom,
    LmDateTime,
    LmDate,
    lmConfirmationModal,
    LmSuperPowerSelect
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      formIsProcessing: false,
      otpToken: '',
      showDigitalSignButton: false,
      showElectronicSignButton: false,
      top: 0
    }
  },
  computed: {
    ...mapState('commons', ['itemDetail', 'tableItems', 'customListTitle', 'customListSubTitles', 'loading']),
    ...mapState('settings', ['collapsedLogoImg']),
    ...mapState('settings', [
      'listTitle',
      'order',
      'orderBySetting',
      'searchOnFields',
      'perPageSetting',
      'defaultItemsPerPage',
      'limitExportFromClient',
      'loading',
      'highlight',
      'apiCallPath',
      'actions',
      'showFilterTime',
      'showGoBackButton',
      'showPDFButton',
      'showCSVButton',
      'downloadCsvFileName',
      'lmListActions',
      'hideSearchSection',
      'hideBreadcrumb',
      'createSegment'
    ]),
    documentsSelected () {
      return this.tableItems.filter(i => i.lmChecked === true)
    },
    documentsSelectedCounter () {
      return this.tableItems.filter(i => i.lmChecked === true).length
    },
    confirmationModalMessage () {
      return `Va a iniciar el proceso de firma para ${this.documentsSelectedCounter} documento${this.documentsSelectedCounter > 1 ? 's' : ''}. Está seguro?`
    }
  },
  watch: {
    listEndpointUri () {
      this.getListSettings(this.listEndpointUri)
    }
  },
  props: {
    title: {
      type: String,
      required: false
    },
    listEndpointUri: {
      type: String,
      required: true
    },
    onSuccessDestinationRoute: {
      type: String,
      required: false,
      default: '/'
    },
    jnlpGeneratorPath: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    ...mapActions('settings', ['geAddOrEditSettings', 'getListSettings']),
    ...mapActions('session', ['getUserInfo']),
    setToken (data) {
      this.otpToken = data.comment
    },
    async digitalSign () {
      try {
        this.formIsProcessing = true
        await this.$refs.lmConfirmationModalFirmar.lmShow()
        const tempLink = document.createElement('a')
        tempLink.href = `${process.env.VUE_APP_API_URL}${this.jnlpGeneratorPath}${this.documentsSelected.map(d => parseInt(d.hidden_n_transac)).join('&id=')}`
        tempLink.setAttribute('download', `signer-multiples.jnlp`)
        tempLink.click()
        // this.lmToastSuccessInternalLink(`/decretos/detail/${this.$route.params.id}`, 'Ver Detalle', 'Decreto enviado al firmador')
        // setTimeout(() => {
        //   this.$router.push('/decretos/firmar')
        // }, 1000)
      } finally {
        this.formIsProcessing = false
      }
    },
    async electronicSign () {
      try {
        this.formIsProcessing = true
        await this.$refs.lmConfirmationModalFirmar.lmShow()
        await commonsApi.axiosPostWrapper(`otp/generate`, this.form)
        this.$refs.lmValidationModalFirmarToken.setIsCommentProps(true, true, 'Codigo')
        await this.$refs.lmValidationModalFirmarToken.lmShow()
        await commonsApi.axiosPostWrapper(`decretos/firmaelectronica`, {
          id: this.documentsSelected.map(d => parseInt(d.hidden_n_transac)),
          token: this.otpToken
        })
        // this.lmToastSuccessInternalLink(`/documentos/editar/${this.$route.params.id}`, 'Ver Detalle', 'Documento Firmado')
        // setTimeout(() => {
        //   this.$router.push('/documentos/todos')
        // }, 1000)
      } finally {
        this.formIsProcessing = false
      }
    },
    onlmCheckedAllSelectedChange (val) {
      // Seleccionamos o deseleccionamos todos
      this.tableItems.filter(i => i.lmChecked === !val).map(i => { i.lmChecked = val })
    }
  },
  async created () {
    const listSettings = await this.getListSettings(this.listEndpointUri)
    this.showDigitalSignButton = listSettings?.showDigitalSignButton || false
    this.showElectronicSignButton = listSettings?.showElectronicSignButton || false
  }
}
</script>
<style lang="sass" scoped>
  .logoImg
    display: none
</style>
